<div class="success relative p-6">
  <div class="content">
    <h2 class="font-extrabold text-4xl text-white mb-2">
      {{title}}
    </h2>

    <p class="text-white text-md lg:text-2xl  mt-4">
      {{subTitle}}
    </p>

    <p class="bg-white rounded-xl p-4 mr-8  mt-10">
      <span class="font-bold text-xl  lg:text-2xl">SIM Serial: </span>
      <span class="text-md lg:text-xl">{{ currentUser?.iccd }}</span> <br />
      <span class="font-bold text-xl  lg:text-2xl">PUK: </span>
      <span class="text-md lg:text-xl">{{ currentUser?.puk }}</span> <br />
      <span class="font-bold text-xl  lg:text-2xl">Número: </span>
      <span class="text-md lg:text-xl">{{ currentUser?.phone }}</span> <br />
    </p>
    <div class="flex justify-center  mt-10">
      <button
        class="bg-red-500 w-[169px] h-[51px] text-[15px] uppercase text-white text-center rounded-full mt-4 p-4 font-extrabold text-xl"
        routerLink="/"
      >
        Finalizar
      </button>
    </div>
  </div>
</div>
